import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, firstValueFrom, from } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {
  private hasCameraSubject = new BehaviorSubject<boolean>(false);
  private isMobileSubject = new BehaviorSubject<boolean>(false);

  constructor() {
    this.checkDeviceCapabilities();
  }

  private checkDeviceCapabilities() {
    // Check if mobile
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    this.isMobileSubject.next(isMobile);

    // Check for camera
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices.getUserMedia({ video: true })
        .then(stream => {
          this.hasCameraSubject.next(true);
          // Clean up the stream immediately
          stream.getTracks().forEach(track => track.stop());
        })
        .catch(() => {
          this.hasCameraSubject.next(false);
        });
    } else {
      this.hasCameraSubject.next(false);
    }
  }

  get hasCamera$(): Observable<boolean> {
    return this.hasCameraSubject.asObservable();
  }

  get isMobile$(): Observable<boolean> {
    return this.isMobileSubject.asObservable();
  }

 get shouldShowCamera$(): Observable<boolean> {
    return from(Promise.all([
      firstValueFrom(this.hasCamera$.pipe(map(hasCamera => hasCamera ?? false))),
      firstValueFrom(this.isMobile$.pipe(map(isMobile => isMobile ?? false)))
    ])).pipe(
      map(([hasCamera, isMobile]) => hasCamera && isMobile)
    );
  }
  
}
